import "./AdminForm.css";
import { useState } from "react";

import { uploadImage } from "../firebase/cloudinaryService";
import { createBlog } from "../firebase/blogService";

const categories = [
  "Web Development",
  "UI/UX",
  "Mobile Apps",
  "Software",
  "Game Development",
  "Technology",
];

const AdminForm = () => {
  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [category, setCategory] = useState(categories[0]);
  const [readTime, setReadTime] = useState(4);

  const [featured, setFeatured] = useState(false);
  const [published, setPublished] = useState(true);

  const [cardImage, setCardImage] = useState(null);
  const [heroImage, setHeroImage] = useState(null);

  const [content, setContent] = useState("");

  // ===============================
  // SEO FIELDS
  // ===============================

  const [seoTitle, setSeoTitle] = useState("");
  const [seoDescription, setSeoDescription] = useState("");
  const [seoKeywords, setSeoKeywords] = useState("");

  // ===============================
  // SLUG
  // ===============================

  const slug = title
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");

  // ===============================
  // SUBMIT
  // ===============================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!cardImage || !heroImage) {
      alert("Please select both Card Image and Hero Image.");
      return;
    }

    if (!seoTitle || !seoDescription) {
      alert("Please fill in the SEO Title and SEO Description.");
      return;
    }

    try {
      // ===============================
      // UPLOAD IMAGES
      // ===============================

      const cardImageUrl = await uploadImage(cardImage);
      const heroImageUrl = await uploadImage(heroImage);

      // ===============================
      // SAVE BLOG TO FIRESTORE
      // ===============================

      await createBlog({
        title,
        slug,
        summary,
        category,
        readTime,
        featured,
        published,

        cardImage: cardImageUrl,
        heroImage: heroImageUrl,

        content,

        author: "Shirdhankar Technologies",

        // ===============================
        // SEO DATA
        // ===============================

        seoTitle,
        seoDescription,
        seoKeywords,
      });

      alert("✅ Blog Published Successfully!");

      // ===============================
      // RESET FORM
      // ===============================

      setTitle("");
      setSummary("");
      setCategory(categories[0]);
      setReadTime(4);

      setFeatured(false);
      setPublished(true);

      setCardImage(null);
      setHeroImage(null);

      setContent("");

      setSeoTitle("");
      setSeoDescription("");
      setSeoKeywords("");

    } catch (error) {
      console.error(error);

      alert("❌ Something went wrong while publishing.");
    }
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>

      {/* ===============================
          BASIC BLOG INFORMATION
      =============================== */}

      <label>Title</label>

      <input
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
      />

      <label>Slug</label>

      <input
        value={slug}
        readOnly
      />

      <label>Category</label>

      <select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
      >
        {categories.map((cat) => (
          <option key={cat} value={cat}>
            {cat}
          </option>
        ))}
      </select>

      <label>Summary</label>

      <textarea
        rows="4"
        value={summary}
        onChange={(e) => setSummary(e.target.value)}
        required
      />

      <label>Read Time (minutes)</label>

      <input
        type="number"
        value={readTime}
        min="1"
        onChange={(e) => setReadTime(Number(e.target.value))}
      />

      {/* ===============================
          PUBLISH SETTINGS
      =============================== */}

      <div className="checkbox-row">

        <label>
          <input
            type="checkbox"
            checked={featured}
            onChange={(e) => setFeatured(e.target.checked)}
          />

          Featured
        </label>

        <label>
          <input
            type="checkbox"
            checked={published}
            onChange={(e) => setPublished(e.target.checked)}
          />

          Published
        </label>

      </div>

      {/* ===============================
          IMAGES
      =============================== */}

      <label>Card Image</label>

      <input
        type="file"
        accept="image/*"
        onChange={(e) => setCardImage(e.target.files[0])}
        required
      />

      <label>Hero Image</label>

      <input
        type="file"
        accept="image/*"
        onChange={(e) => setHeroImage(e.target.files[0])}
        required
      />

      {/* ===============================
          ARTICLE CONTENT
      =============================== */}

      <label>Article Content</label>

      <textarea
        rows="15"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Write your blog article here..."
        required
      />

      {/* ===============================
          SEO
      =============================== */}

      <div className="admin-section-title">
        SEO Settings
      </div>

      <p className="admin-section-description">
        These fields control how this article appears in Google search
        results and when the article is shared on social platforms.
      </p>

      <label>SEO Title</label>

      <input
        value={seoTitle}
        onChange={(e) => setSeoTitle(e.target.value)}
        placeholder="Example: How Much Does It Cost to Develop a Mobile Game?"
        maxLength="60"
        required
      />

      <small>
        Recommended: around 50–60 characters.
      </small>

      <label>SEO Description</label>

      <textarea
        rows="4"
        value={seoDescription}
        onChange={(e) => setSeoDescription(e.target.value)}
        placeholder="Write a short description that explains what this article is about."
        maxLength="160"
        required
      />

      <small>
        Recommended: around 140–160 characters.
      </small>

      <label>SEO Keywords</label>

      <input
        value={seoKeywords}
        onChange={(e) => setSeoKeywords(e.target.value)}
        placeholder="mobile game development, game development cost, Unity game development"
      />

      <small>
        Separate keywords with commas.
      </small>

      {/* ===============================
          PUBLISH BUTTON
      =============================== */}

      <button
        type="submit"
        className="publish-btn"
      >
        Publish Blog
      </button>

    </form>
  );
};

export default AdminForm;